import { TextInput } from '../baseInputs'

type Props = {
  name?: string
  helper?: string
  optional?: boolean
}

const JobTitle = ({ helper, ...rest }: Props) => {
  const name = 'job_title'
  const label = 'Job title'

  return <TextInput name={name} label={label} helper={helper} {...rest} />
}

export default JobTitle
